module.exports = __webpack_public_path__ + "static/img/xjMLogo.061dddde.png";